import { z } from 'zod'

export const LEARNING_ENROLLMENTS_CONTRACT_VERSION = '1.0.0' as const
export const LEARNING_ENROLLMENTS_SCHEMA_VERSION = 'learning-enrollments-v1' as const

const uuid = z.string().uuid()
const requiredText = z.string().trim().min(1).max(240)
const schemaVersion = z.object({ schemaVersion: z.literal(LEARNING_ENROLLMENTS_SCHEMA_VERSION) })

export const learningEnrollmentCreateRequestSchema = schemaVersion.extend({
  memberProfileId: requiredText.max(180),
  programNodeId: requiredText.max(160),
}).strict()

export const learningEnrollmentSchema = z.object({
  enrollmentId: uuid,
  memberProfileId: requiredText.max(180),
  publicationId: uuid,
  publicationN: z.number().int().positive(),
  programNodeId: requiredText.max(160),
  entitlementGrantId: requiredText.max(180),
  status: z.enum(['active', 'paused', 'expired', 'revoked']),
  enrolledAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
}).strict()

export const learningEnrollmentCreateResponseSchema = z.object({
  contract_version: z.literal(LEARNING_ENROLLMENTS_CONTRACT_VERSION),
  item: learningEnrollmentSchema,
  outcome: z.enum(['created', 'reused', 'restored']),
}).strict()

export const learningEnrollmentDetailResponseSchema = learningEnrollmentCreateResponseSchema.omit({ outcome: true })

export type LearningEnrollmentCreateRequest = z.infer<typeof learningEnrollmentCreateRequestSchema>
export type LearningEnrollment = z.infer<typeof learningEnrollmentSchema>
export type LearningEnrollmentCreateResponse = z.infer<typeof learningEnrollmentCreateResponseSchema>
export type LearningEnrollmentDetailResponse = z.infer<typeof learningEnrollmentDetailResponseSchema>
